import { render, staticRenderFns } from "./DepotListView.vue?vue&type=template&id=24f8b33c"
import script from "./DepotListView.vue?vue&type=script&lang=js"
export * from "./DepotListView.vue?vue&type=script&lang=js"
import style0 from "./DepotListView.vue?vue&type=style&index=0&id=24f8b33c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports